import {
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import { Badge } from "V2.0/common/badge";

const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + "...";
};
const MAX_LENGTH = 35;

function ExtractionParameterTable(props) {
  const { extractionParameters, showActions, onEdit, onDelete } = props;

  return (
    <Table className="overflow-y-auto">
      <TableHead className="">
        <TableRow>
          <TableHeader>Field name</TableHeader>
          <TableHeader>Type</TableHeader>
          <TableHeader>Instruction</TableHeader>
          <TableHeader>Mandatory Field</TableHeader>
          {showActions && <TableHeader>Actions</TableHeader>}
        </TableRow>
      </TableHead>
      <TableBody>
        {extractionParameters?.map((item, index) => {
          return (
            <TableRow key={index}>
              <TableCell className="font-medium">
                {truncateText(item.parameterName, MAX_LENGTH)}
              </TableCell>
              <TableCell>
                <Badge
                  color={
                    item.parameterType === "boolean"
                      ? "purple"
                      : item.parameterType === "choice"
                      ? "green"
                      : "rose"
                  }
                >
                  {item.parameterType}
                </Badge>
              </TableCell>
              <TableCell key={index}>
                {truncateText(item.parameterDescription, MAX_LENGTH)}
              </TableCell>
              <TableCell>
                <Badge color={item.isMandatoryField ? "lime" : "orange"}>
                  {item.isMandatoryField ? "Yes" : "No"}
                </Badge>
              </TableCell>
              {showActions && (
                <TableCell>
                  <div className="flex gap-x-2 w-40">
                    {onEdit && (
                      <Button plain onClick={() => onEdit(item, index)}>
                        <PencilIcon />
                      </Button>
                    )}
                    {onDelete && (
                      <Button plain onClick={() => onDelete(item, index)}>
                        <TrashIcon />
                      </Button>
                    )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export { ExtractionParameterTable };
